/**
 * Transform a URL to a React path
 * @param reactPath - The React path to transform
 * @returns The transformed URL
 */
export function transformUrlToReactPath(reactPath: string) {
    const url = new URL(window.location.href);
    const { hostname: originalHostname } = url;
    let currentHostname = originalHostname;
    if (currentHostname && currentHostname.startsWith('edc.')) {
        // Remove 'edc.' and restructure the domain
        const remainingHost = currentHostname.substring(4); // Remove 'edc.'
        currentHostname = remainingHost;
    }

    const queryParams = new URLSearchParams({
        t: Date.now().toString(),
        reactPath,
    });

    // Construct the new URL
    const newUrl = `https://${currentHostname}/#/data-catalog?${queryParams.toString()}`;

    return newUrl;
}

/**
 * Transform a URL by removing 'edc.', restructuring the domain, and adding data-catalog path with timestamp.
 *
 * @param originalUrl - The original URL to transform
 * @returns The transformed URL
 */
export function transformUrl(originalUrl: string) {
    try {
        const url = new URL(originalUrl);

        // Extract the path and query parameters (everything after .xyz) - this is variable x
        const reactPath = url.pathname + (url.search || '');

        // Remove 'edc.' from the hostname and restructure
        return transformUrlToReactPath(reactPath);
    } catch (error) {
        console.error('Error transforming URL:', error);
        return originalUrl; // Return original URL if parsing fails
    }
}
